module.exports = __webpack_public_path__ + "img/footerErWeiMa_charge.c3e589c1.png";